/**
 * Co-Pilot Toggle Button Component
 * Switches between Public Chat and Co-Pilot modes
 */

import React from 'react';
import { ToggleButton, ToggleButtonGroup, Tooltip } from '@mui/material';
import { Chat, Psychology } from '@mui/icons-material';

interface CoPilotToggleProps {
  enabled: boolean;
  onChange: (enabled: boolean) => void;
}

const CoPilotToggle: React.FC<CoPilotToggleProps> = ({ enabled, onChange }) => {
  return (
    <ToggleButtonGroup
      value={enabled ? 'copilot' : 'public'}
      exclusive
      onChange={(_, value) => {
        if (value !== null) {
          onChange(value === 'copilot');
        }
      }}
      size="small"
      sx={{
        '& .MuiToggleButton-root': {
          textTransform: 'none',
          px: 2,
          py: 0.5,
          fontSize: '0.875rem'
        }
      }}
    >
      <Tooltip title="Public customer-facing chat">
        <ToggleButton value="public">
          <Chat sx={{ fontSize: 18, mr: 0.5 }} />
          Public Chat
        </ToggleButton>
      </Tooltip>
      <Tooltip title="Private AI assistant for agents">
        <ToggleButton value="copilot">
          <Psychology sx={{ fontSize: 18, mr: 0.5 }} />
          Co-Pilot
        </ToggleButton>
      </Tooltip>
    </ToggleButtonGroup>
  );
};

export default CoPilotToggle;
